export const CRYPTOS = [
    {
        info: 'sr25519',
        text: 'Schnorrkel (sr25519, recommended)',
        value: 'sr25519'
    },
    {
        info: 'ed25519',
        text: 'Edwards (ed25519, alternative)',
        value: 'ed25519'
    },
    {
        info: 'ecdsa',
        text: 'ECDSA (Non BTC/ETH compatible)',
        value: 'ecdsa'
    }
];
export const CRYPTOS_ETH = [
    {
        info: 'ethereum',
        text: 'ECDSA (ETH compatible)',
        value: 'ethereum'
    }
];
export const CRYPTOS_LEDGER = [
    ...CRYPTOS,
    {
        info: 'ed25519-ledger',
        text: 'Ledger (ed25519, BIP32 derivation)',
        value: 'ed25519-ledger'
    }
];
